import { Link } from '../../components';
import { useAuth } from '../../shared';

export const getOutreachUrl = () => {
  const url = new URL(window.location.origin);

  url.hostname = url.hostname.includes('dev-')
    ? url.hostname.replace('admin', 'outreach')
    : url.hostname.replace(/^(.*?-)?admin\./, 'outreach.');

  return url.toString();
};

export const Products: React.FC = () => {
  const { isSuper, permissions } = useAuth();
  const hasOutreach = isSuper || permissions.some(p => p.includes('outreach'));

  return (
    !!hasOutreach && (
      <div className="py-xs px-md text-small">
        <Link withDecoration withIcon external url={getOutreachUrl()}>
          Go to Outreach
        </Link>
      </div>
    )
  );
};
